function formatFileName(filename = '', prefix = '') {
  return (prefix.trim() + filename.trim())
    .replace(/\s+/gi, '_')
    .replace(/[\\'"]/gi, '')
    .substring(0, 75)
}

export default formatFileName
